// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"b04dd09a","115":"285c5b2f","580":"ad62c489","773":"dac4869d"}[chunkId] + ".chunk.css";
};